<template>
  <v-container fluid>
    <v-progress-circular
      v-if="this.saving"
      indeterminate
      color="green"
      ></v-progress-circular>

    <v-row>
      <v-col cols="12" sm="12" md="12" xs="12" lg="10" xl="10">
        <v-autocomplete
          :items="raz1Items"
          v-model="raz1Selected"
          label="Odaberite razinu 1"
          single-line
          item-text="klasusRaz1"
          item-value="Razina1"
          return-object
          persistent-hint
          clearable
          dense
          outlined
        ></v-autocomplete>
      </v-col>
    </v-row>

    <KlasusLevel2 :raz1Selected="raz1Selected"/>

  </v-container>
</template>
<script>


import KlasusService from '@/services/KlasusService'
import KlasusLevel2 from "./KlasusLevel2.vue";
export default {
  name: 'klasusindex',
  data () {
    return {
      msg: '',
      saving: false,
      raz1: true,
      raz1Items: [],
      raz1Selected: {},
      razUpit: {
        onLevel: 1
      }
    }
  },
  async mounted () {
    try {
      this.saving = true
      await this.findRaz()
      this.saving = false
    } catch (error) {

    }

  },
  methods: {
    async findRaz() {
      if (Object.keys(this.raz1Selected).length > 0) {
        this.razUpit.Razina1 = this.raz1Selected.Razina1
      }
      await KlasusService.choose(this.razUpit).then(res => {
        if (res.data.klasusData) {
          this.raz1Items = res.data.klasusData
        }
      })
      .catch(err => {
        this.havealert = !this.havealert
        this.havemssgalert = 'Error on init Klasus Level 1 ' + err
      })
    }

  },
  computed: {

  },
  watch: {
  //  'raz1Selected'() {
  //    if (this.raz1Selected) {
  //      this.findRaz()
  //    }
  //    if (!this.raz1Selected) {
  //      console.log('sad ga nemam')
  //      this.raz2 = false
  //    }
  //  }
  },
  components: {
    KlasusLevel2
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
